import axios from 'axios'
import store from '@/store'

function authHeaders() {
  const token = store.state.user && store.state.user.token
  return token ? { Authorization: `Bearer ${token}` } : {}
}

function authConfig(config = {}) {
  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      ...authHeaders()
    }
  }
}

export async function getPublicMenu() {
  const { data } = await axios.get('/api/menu', {
    params: { _realtime: Date.now() },
    headers: { 'Cache-Control': 'no-cache' }
  })
  return data
}

export async function searchMenu(q) {
  const { data } = await axios.get('/api/menu/search', { params: { q } })
  return data
}

export async function getAdminMenu() {
  const { data } = await axios.get('/api/menu/admin', authConfig())
  return data
}

export async function createCategory(payload) {
  const { data } = await axios.post('/api/menu/categories', payload, authConfig())
  return data
}

export async function updateCategory(token, payload) {
  const { data } = await axios.post(`/api/menu/categories/${token}`, payload, authConfig())
  return data
}

export async function deleteCategory(token) {
  const { data } = await axios.post(`/api/menu/categories/${token}/delete`, {}, authConfig())
  return data
}

export async function toggleCategory(token, active) {
  const { data } = await axios.post(`/api/menu/categories/${token}/toggle`, { active }, authConfig())
  return data
}

export async function reorderCategories(order) {
  const { data } = await axios.post('/api/menu/categories/reorder', { order }, authConfig())
  return data
}

export async function createFeature(payload) {
  const { data } = await axios.post('/api/menu/features', payload, authConfig())
  return data
}

export async function updateFeature(token, payload) {
  const { data } = await axios.post(`/api/menu/features/${token}`, payload, authConfig())
  return data
}

export async function deleteFeature(token) {
  const { data } = await axios.post(`/api/menu/features/${token}/delete`, {}, authConfig())
  return data
}

export async function toggleFeature(token, active) {
  const { data } = await axios.post(`/api/menu/features/${token}/toggle`, { active }, authConfig())
  return data
}

export async function reorderFeatures(order) {
  const { data } = await axios.post('/api/menu/features/reorder', { order }, authConfig())
  return data
}

export async function uploadFeaturePhoto(token, file) {
  const formData = new FormData()
  formData.append('photo', file)
  const { data } = await axios.post(`/api/menu/features/${token}/photo`, formData, authConfig())
  return data
}

export async function createProduct(payload) {
  const { data } = await axios.post('/api/menu/products', payload, authConfig())
  return data
}

export async function updateProduct(token, payload) {
  const { data } = await axios.post(`/api/menu/products/${token}`, payload, authConfig())
  return data
}

export async function deleteProduct(token) {
  const { data } = await axios.post(`/api/menu/products/${token}/delete`, {}, authConfig())
  return data
}

export async function toggleProduct(token, active) {
  const { data } = await axios.post(`/api/menu/products/${token}/toggle`, { active }, authConfig())
  return data
}

export async function setProductAvailability(token, availabilityStatus) {
  const { data } = await axios.post(
    `/api/menu/products/${token}/availability`,
    { availability_status: availabilityStatus },
    authConfig()
  )
  return data
}

export async function setCustomizationOptionAvailability(productToken, optionToken, availabilityStatus) {
  const { data } = await axios.post(
    `/api/menu/products/${productToken}/customizations/options/${optionToken}/availability`,
    { availability_status: availabilityStatus },
    authConfig()
  )
  return data
}

export async function reorderProducts(categoryToken, order) {
  const { data } = await axios.post('/api/menu/products/reorder', { category_token: categoryToken, order }, authConfig())
  return data
}

export async function getRecipe(productToken) {
  const { data } = await axios.get(`/api/menu/products/${productToken}/recipe`, authConfig())
  return data
}

export async function saveRecipe(productToken, payload) {
  const { data } = await axios.post(`/api/menu/products/${productToken}/recipe`, payload, authConfig())
  return data
}

export async function getWallet() {
  const { data } = await axios.get('/api/loyalty/wallet', authConfig({ params: { _realtime: Date.now(), include_history: 0 } }))
  return data
}

export async function getWalletHistory() {
  const { data } = await axios.get('/api/loyalty/history', authConfig({ params: { _realtime: Date.now() } }))
  return data
}

export async function getRedemptions(filter = 'pending', page = 1) {
  const { data } = await axios.get('/api/loyalty/redemptions', authConfig({ params: { filter, page, _realtime: Date.now() } }))
  return data
}

export async function getRedemption(uuid) {
  const { data } = await axios.get(`/api/loyalty/redemptions/${encodeURIComponent(uuid)}`, authConfig({ params: { _realtime: Date.now() } }))
  return data
}

export async function getRewards() {
  const { data } = await axios.get('/api/loyalty/rewards', authConfig())
  return data
}

export async function claimTicket(ticket_uuid) {
  const { data } = await axios.post('/api/loyalty/claim-ticket', { ticket_uuid }, authConfig())
  return data
}

export async function getTicketPreview(ticketUuid) {
  const { data } = await axios.get(`/api/loyalty/tickets/${encodeURIComponent(ticketUuid)}/preview`, {
    headers: { 'Cache-Control': 'no-cache' }
  })
  return data
}

export async function redeemRewards(items) {
  const { data } = await axios.post('/api/loyalty/redeem', { items }, authConfig())
  return data
}


export async function getLoyaltyAdminSettings() {
  const { data } = await axios.get('/api/loyalty/admin/settings', authConfig())
  return data
}

export async function saveLoyaltyAdminSettings(payload) {
  const { data } = await axios.post('/api/loyalty/admin/settings', payload, authConfig())
  return data
}

export async function testLoyaltyAdminConnection() {
  const { data } = await axios.post('/api/loyalty/admin/test-connection', {}, authConfig())
  return data
}

export async function getMenuAnnouncementAdmin() {
  return (await axios.get('/api/menu/announcement/admin', authConfig())).data
}
export async function saveMenuAnnouncement(payload) {
  return (await axios.post('/api/menu/announcement/admin', payload, authConfig())).data
}
